/* eslint-disable no-console */
/** @ts-check */

(function () {
  "use strict";

  /* ===================
     BV CART PROGRESS
  ===================== */

  let isLoading = false;
  let refreshTimeout = null;
  
  /**
   * Updates the progress bar based on the current cart total
   * @param {HTMLElement} container - container element of the progress bar
   * @param {number} cartTotal - basket total price in euros
   */
  function updateProgressBar(container, cartTotal) {
    const fillEl = container.querySelector('.bv-progress-fill');
    const msgEl = container.querySelector('.bv-progress-message-text');

    if (!fillEl || !msgEl) return;

    const enableShip = container.dataset.enableShip === "true";
    const ship = parseFloat(container.dataset.ship || "0");
    const messageShipping = container.dataset.messageShipping || "Spend ${{amount}} more for Free Delivery!";
    const messageUnlocked = container.dataset.messageUnlocked || "Hooray! You've unlocked Free Delivery!";

    let percent = 0;
    let message = '';
    let isCompleted = false;

    if (enableShip && ship > 0) {
      percent = Math.min((cartTotal / ship) * 100, 100);
      
      if (cartTotal < ship) {
        const remaining = (ship - cartTotal).toFixed(2);
        message = messageShipping.replace(/\{\{amount\}\}/g, remaining);
        isCompleted = false;
      } else {
        message = messageUnlocked;
        isCompleted = true;
      }
    }

    if (isCompleted) {
      container.classList.add('bv-cart-progress--completed');
    } else {
      container.classList.remove('bv-cart-progress--completed');
    }

    if (message.trim()) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = message;
      msgEl.innerHTML = tempDiv.innerHTML;
    } else {
      msgEl.innerHTML = '';
    }

    const fillWidth = 100 - percent;
    fillEl.style.width = fillWidth + '%';

    hideLoading();
  }

  function showLoading() {
    const container = document.querySelector('.bv-cart-progress');
    if (!container) return;
    
    const overlay = container.querySelector('.bv-progress-loading-overlay');
    if (overlay) {
      overlay.classList.add('active');
    }
  }

  function hideLoading() {
    const container = document.querySelector('.bv-cart-progress');
    if (!container) return;
    
    const overlay = container.querySelector('.bv-progress-loading-overlay');
    if (overlay) {
      overlay.classList.remove('active');
    }
  }

  function getProgressContainer() {
    return document.querySelector('.bv-cart-progress');
  }

  function isInsideClosedCartDrawer(container) {
    const drawer = container?.closest('cart-drawer-component');
    if (!drawer) return false;

    const dialog = drawer.querySelector('dialog');
    return !(dialog instanceof HTMLDialogElement) || !dialog.open;
  }

  function canRefreshProgress() {
    const container = getProgressContainer();
    return !!container && !isInsideClosedCartDrawer(container);
  }

  function refreshProgress() {
    if (isLoading) return;
    if (!canRefreshProgress()) return;
    
    const container = getProgressContainer();
    if (!container) return;
    
    isLoading = true;
    showLoading();

    fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(response => response.json())
      .then(cart => {
        const cartTotal = cart.total_price / 100;
        const container = document.querySelector('.bv-cart-progress');
        if (container) {
          updateProgressBar(container, cartTotal);
        }
        isLoading = false;
      })
      .catch(error => {
        console.warn('[BV Cart] Failed to refresh:', error);
        hideLoading();
        isLoading = false;
      });
  }

  function debouncedRefresh() {
    if (refreshTimeout) {
      clearTimeout(refreshTimeout);
    }
    refreshTimeout = setTimeout(() => {
      refreshProgress();
      refreshTimeout = null;
    }, 50);
  }

  function isCartPriceRefreshActive() {
    return Number(window.__BV_CART_PRICE_REFRESH_UNTIL || 0) > Date.now();
  }

  // Init on page load
  function init() {
    if (!canRefreshProgress()) return;

    setTimeout(refreshProgress, 100);
  }

  // Event listeners for cart updates - adjust as needed based on your theme's events
  document.addEventListener('DOMContentLoaded', init);
  
  // document.addEventListener('cart:update', debouncedRefresh);
  document.addEventListener('cart:updated', debouncedRefresh);
  // document.addEventListener('cart:refresh', debouncedRefresh);
  
  document.addEventListener('cart-drawer:open', () => {
    setTimeout(() => {
      if (isCartPriceRefreshActive()) return;

      const container = getProgressContainer();
      const msgEl = container?.querySelector('.bv-progress-message-text');
      
      if (msgEl && msgEl.innerHTML.trim() === '') {
        refreshProgress();
      }
    }, 100);
  });

  document.addEventListener('click', (e) => {
    if (e.target?.closest('[data-testid="cart-drawer-trigger"]')) {
      setTimeout(() => {
        if (isCartPriceRefreshActive()) return;

        const container = getProgressContainer();
        const msgEl = container?.querySelector('.bv-progress-message-text');
        
        if (msgEl && msgEl.innerHTML.trim() === '') {
          refreshProgress();
        }
      }, 150);
    }
  });

  const observer = new MutationObserver(() => {
    if (isCartPriceRefreshActive()) return;
    if (!canRefreshProgress()) return;

    const container = getProgressContainer();
    const msgEl = container?.querySelector('.bv-progress-message-text');
    
    if (container && msgEl && msgEl.innerHTML.trim() === '' && !isLoading) {
      refreshProgress();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  } else {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
